export default "__VITE_ASSET__t1Pqn4wQ__"